var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.description,
            expression: "description",
          },
        ],
        staticClass: "description-text tender-font",
      },
      [_vm._v(_vm._s(_vm.description))]
    ),
    _vm._v(" "),
    _vm.showTenderHints
      ? _c("p", { staticClass: "hint" }, [
          _vm._v(_vm._s(_vm.$t("tender.attachment.attachmentNotes"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "table",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.files.length > 0,
            expression: "files.length>0",
          },
        ],
        staticClass: "tender-tnc-table",
      },
      [
        _c("thead", [
          _c("th", { staticClass: "number tender-font" }, [_vm._v("#")]),
          _vm._v(" "),
          _c("th", { staticClass: "filename tender-font" }, [
            _vm._v(_vm._s(_vm.$t("tender.attachment.document"))),
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "description tender-font" }, [
            _vm._v(_vm._s(_vm.$t("tender.attachment.description"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.sortedFiles, function (item, index) {
              return [
                _c(
                  "tr",
                  {
                    staticClass: "set-border-top",
                    class: _vm.highlightForAddendumChange(item),
                  },
                  [
                    _c("td", { staticClass: "number tender-font" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "filename tender-font" }, [
                      _c(
                        "a",
                        {
                          staticStyle: { "text-decoration": "underline" },
                          attrs: { target: "terms_conditions" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadFile(item.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.filename))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "description tender-font" }, [
                      _c("div", { staticClass: "description-text" }, [
                        _vm._v(_vm._s(item.description)),
                      ]),
                    ]),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.files.length > 0,
            expression: "files.length > 0",
          },
        ],
        staticClass: "tnc-download-all clearfix",
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn--orange tender-sticky-button float-right",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.downloadAll()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("action.downloadAll")))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }